import React, { Children, Component } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
import { benefitIconMap } from '../ui/icons/BenefitIcons';
export function Benefits() {
  const {
    t
  } = useLanguage();
  const items: {
    title: string;
    desc: string;
    key: string;
  }[] = t('benefits.items');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: easeOutCubic
      }
    }
  };
  return <section id="beneficios" className="py-24 lg:py-40 bg-white" data-id="element-50">
      <div className="container mx-auto px-6" data-id="element-51">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-52">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-53">
            {t('benefits.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-54">
            {t('benefits.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-55">
            {t('benefits.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-56"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16" data-id="element-57">
          {items.map(item => {
          const IconComponent = benefitIconMap[item.key];
          return <motion.div key={item.key} variants={itemVariants} className="flex flex-col items-start group" data-id="element-58">
                <div className="mb-6 text-brand-dark/40 group-hover:text-brand-gold transition-colors duration-500" data-id="element-59">
                  {IconComponent && <IconComponent className="w-8 h-8" strokeWidth={1} data-id="element-60" />}
                </div>
                <h3 className="text-xl font-serif font-normal text-brand-dark mb-3" data-id="element-61">
                  {item.title}
                </h3>
                <p className="text-brand-dark/60 font-light leading-relaxed" data-id="element-62">
                  {item.desc}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}